import { MouseEventHandler } from 'react'
import {
  Box,
  Stack,
  Typography,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  Divider,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { WVerifyBadgeIcon } from '@weblite/icons'
import { nothing } from '$func/utils'

const StyledDivider = styled(Divider)`
  &:last-child {
    display: none;
  }
`

const StyledListItem = styled(ListItem)(({ theme }) => ({
  height: 56,
  backgroundColor: theme.palette.white,
}))

const StyledListItemButton = styled(ListItemButton)`
  height: 100%;
  box-sizing: border-box;
  padding: 0 15px;
`

interface Props {
  avatarComponent: JSX.Element
  primaryTextIcon?: JSX.Element
  primaryText: JSX.Element
  verified?: boolean
  secondaryActionComponent?: JSX.Element
  secondaryText?: string | JSX.Element
  hasDivider?: boolean
  onClick?: () => unknown
  onContextMenu?: unknown
}

export function ChatListItemBase({
  avatarComponent,
  primaryTextIcon,
  primaryText,
  verified,
  secondaryActionComponent,
  secondaryText,
  hasDivider,
  onClick,
  onContextMenu,
}: Props) {
  return (
    <>
      <StyledListItem disablePadding>
        <StyledListItemButton
          onClick={onClick}
          onContextMenu={onContextMenu as MouseEventHandler<HTMLDivElement>}
        >
          <ListItemAvatar>{avatarComponent}</ListItemAvatar>
          <Stack
            justifyContent="center"
            sx={{
              width: '100%',
              height: '100%',
              overflow: 'hidden',
              gap: '4px',
            }}
          >
            <Box sx={{ display: 'flex', overflow: 'hidden' }}>
              {primaryTextIcon}
              {primaryText}
              {verified && (
                <WVerifyBadgeIcon
                  sx={{ width: '20px', height: '20px', color: 'primary500' }}
                />
              )}
            </Box>

            {typeof secondaryText === 'string' ? (
              <Typography variant="caption1" sx={{ color: '#9DA3AA' }}>
                {secondaryText}
              </Typography>
            ) : (
              secondaryText
            )}
          </Stack>
        </StyledListItemButton>
        {secondaryActionComponent}
      </StyledListItem>
      {hasDivider && <StyledDivider variant="inset" />}
    </>
  )
}

ChatListItemBase.defaultProps = {
  secondaryText: null,
  primaryTextIcon: null,
  secondaryActionComponent: null,
  hasDivider: true,
  onClick: nothing,
  verified: false,
  onContextMenu: nothing,
}
